<template>
    <v-main>
      <div id="app">
        <v-app> 
         <Layout></Layout>
        </v-app> 
      </div>
    </v-main>
</template>

<script>
  import Layout from './components/Layout.vue';



  export default {
    name: 'App',

    components:{
      Layout
    },

    created () {
    },

    methods: {
      
    },
    data() {
      return{
      }
    }
  }
</script>

<style lang="scss">

* {
  box-sizing: border-box;
}

</style>
